export const TextRow = ({num = -1, stmt, text}) => {
    return (
        <div className="d-flex flex-row align-items-center fs-5 gap-4">
            <div className="flex-grow-1">
                <div className="d-flex ">
                    {num !== -1 && (
                        <div className="d-flex flex-column">
                            <div className="symbol symbol-30px me-4">
                                <div className="symbol-label fs-5 fw-semibold bg-primary text-inverse-danger">
                                    {num}
                                </div>
                            </div>
                        </div>
                    )}
                    <span className="d-flex flex-column pt-1">
                        <div className="d-flex flex-row fw-bold">{stmt}</div>
                        <div className="d-flex flex-row mt-2">{text}</div>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default TextRow
